import { Container } from 'components/container'
import { motion } from 'framer-motion'
import styled, { css } from 'styled-components/macro'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const Section = styled.div`
  margin-block: 5rem;
  overflow: hidden;

  ${mq.smallOnly} {
    ${Container} {
      padding-inline: 0;
    }
  }

  ${mq.large} {
    margin-block: 6rem;
  }
`

export const SectionTitle = styled.h2`
  padding-inline: 1em;
  font-size: clamp(3rem, 8vw, 4.8rem);
  font-weight: 700;
  text-align: center;
`

export const Item = styled(motion.div)<{ $isInView: boolean }>`
  position: relative;
  margin: 2rem 0;
  transition: all 0.8s ${theme.ease.out};

  ${mq.medium} {
    margin: 6rem 0;
    width: 80%;
  }

  ${mq.large} {
    width: 66.6%;
  }

  ${props =>
    !props.$isInView &&
    css`
      opacity: 0;
      transform: translateY(20%);

      ${mq.medium} {
        transform: translateX(-20%);

        &:nth-child(2n) {
          transform: translateX(20%);
        }
      }
    `}

  &:nth-child(2n) {
    margin-left: auto;
  }
`

export const Image = styled.img`
  display: block;
  width: 100%;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  padding: 2.5rem;
  text-align: center;
  color: white;

  ${mq.medium} {
    padding: 4rem;
    width: 75%;
  }

  ${mq.large} {
    padding: 6rem;
    width: 50%;
  }

  ${Item}:nth-child(2n) & {
    right: auto;
    left: 0;
  }
`

export const Title = styled.h3`
  margin-block: 0.3em;
  font-size: 3.7rem;
`
